exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-container[data-v-f5d20e40] figure{margin:0}.img-container[data-v-f5d20e40] img{width:100%;max-width:500px}.custom-bg-gray-light[data-v-f5d20e40]{background:#e7e9ef}", ""]);

// exports
